export default __webpack_public_path__ + "static/media/bubble_nova_background_s1.ac0f549d.jpg";